import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="April 26, 2026">
      <p>
        Welcome to Jingle Hooks. By using our service you agree to these terms. If you do not agree, please do not use the product.
      </p>

      <h2>1. The service</h2>
      <p>
        Jingle Hooks is an AI-powered platform that converts ad scripts into audio jingles, brand songs, and anthems. Service features, pricing, and availability may change with reasonable notice.
      </p>

      <h2>2. Eligibility & account</h2>
      <p>
        You must be 18+ and authorised to enter this agreement. You are responsible for keeping your Google account credentials secure.
      </p>

      <h2>3. Credits & billing</h2>
      <ul>
        <li>1 credit = 1 second of generated music.</li>
        <li>Free trial grants 30 credits for new users (2 × 15s jingles).</li>
        <li>Pay-per-use grants 40 credits for ₹799 (one-time).</li>
        <li>Pro subscription grants 450 credits per month for ₹7,999; unused credits roll over.</li>
        <li>Top-ups start at ₹300 (₹20 per credit).</li>
        <li>All prices are inclusive of applicable taxes unless stated otherwise.</li>
      </ul>

      <h2>4. Licence & ownership</h2>
      <p>
        You own the final jingles you generate and may use them for <strong>commercial purposes</strong> including ads, reels, brand campaigns, and paid distribution. We retain a non-exclusive right to use anonymised prompt/output data for product improvement.
      </p>

      <h2>5. Prohibited use</h2>
      <p>Do not use Jingle Hooks to generate content that:</p>
      <ul>
        <li>Infringes third-party copyrights, trademarks or publicity rights.</li>
        <li>Promotes hate, violence, or sexually explicit material involving minors.</li>
        <li>Impersonates a real person, brand, or public figure without consent.</li>
        <li>Violates any applicable law in your jurisdiction.</li>
      </ul>
      <p>Violations may result in immediate account termination without refund.</p>

      <h2>6. Service availability & output quality</h2>
      <p>
        We target 99% uptime but do not guarantee uninterrupted service. AI-generated audio quality can vary. Credits for failed generations are refunded automatically.
      </p>

      <h2>7. Payment, refunds & cancellation</h2>
      <p>
        See our <a href="/refund">Refund Policy</a>. Subscriptions renew automatically and can be cancelled anytime from your dashboard or by emailing <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a>.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the extent permitted by law, our total liability for any claim is limited to the amount you paid us in the previous 3 months. We are not liable for indirect, consequential, or lost-profit damages.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update these terms with 14 days' notice. Continued use after the effective date constitutes acceptance.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These terms are governed by the laws of India. Disputes will be resolved in the courts of Bengaluru, Karnataka.
      </p>

      <h2>11. Contact</h2>
      <p>
        <strong>Email:</strong> <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a>
      </p>
    </LegalLayout>
  );
}
